import { useContext } from 'react';
import { LoadContext } from '../../utils/Load/LoadContext';
export const useLoad = () => useContext(LoadContext);
